import './Header.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import { Cart } from 'types/cart';
import { RemoteData } from 'app/store/remoteData';
import * as Core from 'components/core';
import { Link } from 'components/core';
import CartLink from 'components/layout/CartLink';
import QLabIcon from 'components/QLabIcon';
import { AppState } from 'app/store';
import { getSessionUser } from 'app/stateHelpers';
import mobileMenuCloseImage from 'assets/mobile-menu-close.svg';
import mobileMenuImage from 'assets/mobile-menu.svg';
import SignOut from 'app/actionCreators/SignOut';
type PropsFromAppState = {
  signedIn: boolean;
  checkoutComplete: boolean;
  cartRemoteData: RemoteData<Cart>;
};
type Props = {
  sessionInitFailedMessage: React.ReactNode | undefined | null;
} & PropsFromAppState;
type State = {
  mobileNavExpanded: boolean;
};
type NavMenuItem = [string, string]; // href
const primaryNav: Array<NavMenuItem> = [
  ['Overview', '/overview/'],
  ['Documentation', `/docs/v${ENV.QLAB_CURRENT_MAJOR_VERSION}/`],
  ['Learn QLab', '/learn-qlab/'],
  ['Support', '/support/'],
  ['Remote', '/qlab-remote/'],
];
const secondaryNav: Array<NavMenuItem> = [
  ['Download', '/download/'],
  ['Shop', '/shop/'],

  // the following are handled in the component as special cases:
  // Account
  // Cart
  // Sign Out
];
function mapAppStateToProps(appState: AppState): PropsFromAppState {
  return {
    cartRemoteData: appState.shop.cart,
    checkoutComplete: appState.pages.checkoutPage.checkoutComplete,
    signedIn: getSessionUser(appState) !== null,
  };
}
class Header extends React.Component<Props, State> {
  state = {
    mobileNavExpanded: false,
  };
  hideMobileNav = () => {
    this.setState({
      mobileNavExpanded: false,
    });
  };
  showMobileNav = () => {
    this.setState({
      mobileNavExpanded: true,
    });
  };
  reload = () => {
    window.location.reload();
  };
  render() {
    const {
      cartRemoteData,
      signedIn,
      checkoutComplete,
      sessionInitFailedMessage,
    } = this.props;
    const { mobileNavExpanded } = this.state;
    const cart = cartRemoteData.value;
    return (
      <div className="Header">
        {sessionInitFailedMessage && (
          <div className="Header-sessionInitFailed">
            {sessionInitFailedMessage}
          </div>
        )}

        <Core.ContentWrapper>
          <div className="Header-nav">
            <Link className="Header-nav-brand" to="/">
              <QLabIcon className="Header-nav-brand-image" />
              QLab
            </Link>
            <div className="Header-nav-items">
              <nav className="Header-nav-items-primaryGroup">
                {primaryNav.map((link) => (
                  <Link
                    data-testid={`${link[0]}-link`.toLowerCase()}
                    key={link[1]}
                    className="Header-nav-items-link"
                    to={link[1]}
                  >
                    {link[0]}
                  </Link>
                ))}
              </nav>

              <nav className="Header-nav-items-secondaryGroup">
                {secondaryNav.map((link) => (
                  <Link
                    data-testid={`${link[0]}-link`.toLowerCase()}
                    key={link[1]}
                    className="Header-nav-items-link"
                    to={link[1]}
                  >
                    {link[0]}
                  </Link>
                ))}

                <Link className="Header-nav-items-link" to="/account/">
                  {signedIn ? 'Account' : 'Sign In'}
                </Link>

                {signedIn && (
                  <Core.Button
                    onClick={SignOut}
                    className="Header-nav-items-link Button"
                  >
                    Sign Out
                  </Core.Button>
                )}

                <CartLink cart={cart} checkoutComplete={checkoutComplete} />
              </nav>
            </div>
            {mobileNavExpanded ? (
              <button
                className="Header-nav-mobileButtonHide"
                onClick={this.hideMobileNav}
              >
                <img
                  className="Header-nav-mobileButtonHide-image"
                  src={mobileMenuCloseImage}
                  alt="Close Navigation"
                />
              </button>
            ) : (
              <button
                className="Header-nav-mobileButtonShow"
                onClick={this.showMobileNav}
              >
                <img
                  className="Header-nav-mobileButtonShow-image"
                  src={mobileMenuImage}
                  alt="Show Navigation"
                />
              </button>
            )}
          </div>
        </Core.ContentWrapper>

        {mobileNavExpanded && (
          <nav className="Header-mobileNav">
            <div className="Header-mobileNav-primaryGroup">
              {primaryNav.map((link) => (
                <div key={link[1]} className="Header-mobileNav-item">
                  <Link to={link[1]}>{link[0]}</Link>
                </div>
              ))}
            </div>
            <div className="Header-mobileNav-secondaryGroup">
              {secondaryNav.map((link) => (
                <div key={link[1]} className="Header-mobileNav-item">
                  <Link to={link[1]}>{link[0]}</Link>
                </div>
              ))}
              <div className="Header-mobileNav-item">
                <Link to="/account/">{signedIn ? 'Account' : 'Sign In'}</Link>
              </div>
              <div className="Header-mobileNav-item">
                <Link to="/checkout/">Cart</Link>
              </div>
              {signedIn && (
                <div className="Header-mobileNav-item">
                  <Core.Button textLink onClick={SignOut}>
                    Sign Out
                  </Core.Button>
                </div>
              )}
            </div>
          </nav>
        )}
      </div>
    );
  }
}
export default connect(mapAppStateToProps)(Header);
